import packageJson from '../../../../package.json';
import './AppVersion.css';

const AppVersion = (): JSX.Element => {
    return <div className="app-version">v{packageJson.version}</div>;
};

export default AppVersion;
